import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import ImageUploader from '../components/collections/ImageUploader'
import { useDispatch, useSelector } from 'react-redux';
import { fetchCreateCollection, updateField } from '../redux/slices/CollectionSlice';
import { useAccount } from 'wagmi';
import { CHAIN_INFO, DEFAULT_CHAIN, SUPPORTED_CHAIN } from '../helper/constant';
import nftmasterAbi from '../abis/nftmaster.json';
import { addLoader, removeLoader } from '../redux/slices/UserSlice';
import { useToasts } from 'react-toast-notifications';
import { formatPrice, getCreateCollectionEvent, getCurrentChain, getWeb3 } from '../helper/functions';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../helper/api';
import { getContract } from '../helper/contractHelper';
import { useEthersSigner } from '../stats/useEthersSigner';
import { useCommonStats } from '../stats/useCollection';
import { ethers } from 'ethers';

export default function CreateCollection() {
  const dispatch = useDispatch();
  let { id } = useParams();
  const nname = useSelector((state) => state.collection.name);
  const symbol = useSelector((state) => state.collection.symbol);
  const total_supply = useSelector((state) => state.collection.total_supply);
  const { address, chainId } = useAccount();
  const signer = useEthersSigner(getCurrentChain(chainId))
  const { addToast, removeAllToasts } = useToasts();
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const navigate = useNavigate();
  const state = useCommonStats();

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateField({ field: name, value }));
  };

  useEffect(() => {
    async function fetch() {
      const response = await api.get('collection/categories', {
        params: {
          limit: 10,
        }
      })

      if (response && response.data && response.data.error === 'OK') {
        setCategories(response.data.data);
      }

      getCreateCollectionEvent('dfhfh')
    }

    fetch();
  }, []);


  const handleCreate = async () => {
    try {
      if (!nname || !symbol) {
        addToast('name ,symbol and total supply must required', { appearance: 'error', });
        return false;
      }
      dispatch(addLoader());
      if (address) {
        if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
          let masterContract = getContract(nftmasterAbi, CHAIN_INFO[chainId].nft_master, signer);
          let arags = id === 'erc1155' ? [address, nname, symbol] : [address, nname, symbol, total_supply]
          let tx;
           

          if (id === 'erc1155') {
            tx = await masterContract.createCollectionERC1155(
              ...arags,
              { 'from': address , value : ethers.utils.parseEther(state.price.toString()) });
          }
          else {
            tx = await masterContract.createCollectionERC721(
              ...arags,
              { 'from': address , value : ethers.utils.parseEther(state.price.toString()) });
          }

          var interval = setInterval(async function () {
            let web3 = getWeb3(chainId ? chainId : DEFAULT_CHAIN);
            var response = await web3.eth.getTransactionReceipt(tx.hash);
            if (response != null) {
              clearInterval(interval)
              if (response.status === true) {
                addToast('Transaction completed successfully.', { appearance: 'success', });
                let nftAddres = await getCreateCollectionEvent(tx.hash, chainId);
                if (nftAddres) {
                  await new Promise(resolve => setTimeout(resolve, 10000));
                  await dispatch(fetchCreateCollection({
                    nftAddres, hash: tx.hash, address, categoryId
                  }));
                  dispatch(removeLoader());
                  navigate(`/collection/${nftAddres}`);
                }
                else {
                  addToast('something went wrong.', { appearance: 'error', });
                  dispatch(removeLoader());
                }
              }
              else if (response.status === false) {
                addToast('error ! Your last transaction is failed.', { appearance: 'error', });
                dispatch(removeLoader());
              }
              else {
                addToast('error ! something went wrong.', { appearance: 'error', });
                dispatch(removeLoader());
              }
            }
          }, 5000);
        } else {
          dispatch(removeLoader());
          removeAllToasts();
          addToast('Please switch chain to Base mainnet', { appearance: 'error' });
        }
      } else {
        dispatch(removeLoader());
        removeAllToasts();
        addToast('Please connect wallet', { appearance: 'error' });
      }
    } catch (err) {
      dispatch(removeLoader());
      removeAllToasts();
      addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
      console.error(err.message);
    }
  };


  return (
    <Layout>
      <section class="mt-5">
        <div class="center-y relative text-center">
          <div class="container">
            <div class="row">

              <div class="col-md-12 text-center">
                <h1>Create Collection Contract</h1>
              </div>
              <p>You’ll need to deploy an {id === 'erc1155' ? "ERC-1155" : "ERC-721"} contract onto the blockchain</p>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </section>
      <section className='pt-0' aria-label="section">
        <div class="container">
          <div class="row wow fadeIn d-flex justify-content-center">
            <div class="col-lg-7 offset-lg-1">
              <form id="form-create-item" class="form-border" method="post" action="email.php">
                <div class="field-set">
                  <div className='row'>
                    <div className='col-12 col-md-6'>
                      <label>Upload Banner</label>
                      <ImageUploader type="banner" />
                    </div>
                    <div className='col-12 col-md-6'>
                      <label>Upload Profile</label>
                      <ImageUploader type="profile" />
                    </div>
                  </div>

                  <div class="spacer-40"></div>
                  <div className='row'>
                    <div className='col-12 col-md-8'>
                      <label>Contract name</label>
                      <input type="text" value={nname} onChange={(e) => handleChange(e)} name="name" id="name" class="form-control" placeholder="e.g. BlockStar NFT" />
                      <div class="spacer-20"></div>
                    </div>
                    <div className='col-12 col-md-4'>
                      <label>Token symbol</label>
                      <input type="text" value={symbol} onChange={(e) => handleChange(e)} name="symbol" id="symbol" class="form-control" placeholder="e.g. BSTNFT" />
                      <div class="spacer-20"></div>
                    </div>
                  </div>


                  <div class="spacer-20"></div>
                  <div className='row'>
                    {id !== 'erc1155' &&
                      <div className='col-12 col-md-6'>
                        <label>Total Supply</label>
                        <input type="text" value={total_supply} onChange={(e) => handleChange(e)} name="total_supply" id="total_supply" class="form-control" placeholder="e.g. 1000" />
                      </div>
                    }
                    <div className='col-12 col-md-6'>
                      <label>Categories</label>
                      <select onChange={(e) => setCategoryId(e.target.value)} class="form-select">
                        <option selected disabled>Select Option</option>
                        {categories && categories.map((items, key) => {
                          return (
                            <option key={key} value={items.id}>
                              {items.name}
                            </option>
                          )
                        })}
                      </select>

                    </div>
                  </div>

                  
                  <div class="spacer-20"></div>
                  {state.price && <p className='text-danger'>Fees : {formatPrice(state.price)} BST</p>}
                  <div class="spacer-20"></div>
                  <div className='d-flex justify-content-end mt-5'>
                    <button type="button" class="btn-main" onClick={() => handleCreate()}>Create Collection</button>
                  </div>
                  <div class="spacer-single"></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}
